// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon.disable{opacity:.5;pointer-events:none !important}", "",{"version":3,"sources":["webpack://./src/components/Icon/Icon.scss"],"names":[],"mappings":"AACE,cACE,UAAA,CACA,8BAAA","sourcesContent":[".icon {\n  &.disable {\n    opacity: 0.5;\n    pointer-events: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
